
import { defineComponent } from '@vue/composition-api';
import {
  EventDetailsEvent,
  EventDetailsMarketsGroup,
  PreviewOdd,
  PreviewOutcome,
  PreviewEventGroup,
  Tournament
} from '../../../../types/sport';
import icons from '../components/icons.vue';
import CompetitorIcon from '../Icons/CompetitorIcon.vue';
import { formatDateAndTime } from '@/composables/utils';
import IllinoisTabBar from '../components/TabBar.vue';
import OddsExpandableCard from '../components/OddsComponents/OddsExpandibleCard.vue';
import useOdds from '@/composables/useOdds';
import { GenericOption } from '../../../../types/components';
import { getCorrectData, addOddToCartV3FromSport } from '@/composables/useOdds';
import ChangePageModal from '../components/ChangePageModal.vue';
import { useApiV3 } from '@/composables/apiV3';
import { formattedDate, formatTime } from '@/composables/utils';
import EventItem from '../components/EventItem.vue';
import EventGroup from '../components/EventGroup.vue';
export default defineComponent({
  name: 'EventPage',
  props: {
    eventId: {
      type: String,
      required: true
    },
    sportId: {
      type: String,
      required: true
    },
    categoryId: {
      type: String,
      required: true
    },
    tournamentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      error: null as string | null,
      activeMarketGroup: null as string | null,
      urlCloudfront:
        process.env.VUE_APP_URL_CLOUDFRONT + '/illinoisSlider/event-bg.webp',
      activeSpread: {} as Record<string, string>,
      correctMarket: '5185578776' as string | null,
      correctMarket2: '7836838694' as string | null,
      openChangeGameMenu: false,
      showEventsList: false,
      isEventsListLoading: false,

      showTournamentsList: false,
      isTournamentsListLoading: false,
      tournamentSelectedId: this.tournamentId,
      tournamentSelectedName: '',
      windowHeight: window.innerHeight,
      isMarketLoading: false
    };
  },
  components: {
    icons,
    CompetitorIcon,
    IllinoisTabBar,
    OddsExpandableCard,
    ChangePageModal,
    EventItem,
    EventGroup
  },

  methods: {
    addOddToCartV3FromSport,
    async handleOpenChangeGameMenu() {
      this.showTournamentsList = false;
      this.tournamentSelectedId = this.tournamentId;
      this.isEventsListLoading = true;
      await this.fetchEventsByTournament({
        sportId: this.sportId,
        categoryId: this.categoryId,
        tournamentId: this.tournamentId.toString()
      });
      this.isEventsListLoading = false;
      this.openChangeGameMenu = true;
    },
    hasActiveOutcomes(oddGroup: PreviewOdd[]): boolean {
      if (!Array.isArray(oddGroup) || oddGroup.length === 0) return false;
      return oddGroup.some((odd: PreviewOdd) =>
        Array.isArray(odd.outcome)
          ? (odd.outcome as PreviewOutcome[]).some(
              (outcome: PreviewOutcome) => outcome.status === 1
            )
          : false
      );
    },
    async fetchEventsByTournament(payload: {
      sportId: string;
      categoryId: string;
      tournamentId: string;
    }) {
      this.isEventsListLoading = true;
      await this.$store.dispatch(
        'IllinoisSport/fetchEventsByTournament',
        payload
      );
      this.isEventsListLoading = false;
    },
    hasOddGroupData(oddGroup: PreviewOdd[]): boolean {
      if (!Array.isArray(oddGroup) || oddGroup.length === 0) return false;
      return oddGroup.some(odd => {
        const outcomes = Array.isArray(odd?.outcome)
          ? (odd.outcome as PreviewOutcome[])
          : [];
        return outcomes.length > 0;
      });
    },
    handleChangeTab(tab: string) {
      console.log('tab', tab);
      this.activeMarketGroup = tab;
    },
    t(key: string, values?: Record<string, unknown> | any[]) {
      return this.$t(key, values) as string;
    },
    getCorrectData,
    formattedDate,
    formatDateAndTime,
    useOdds,
    formatTime,
    distributeIntoColumns(
      items: PreviewOutcome[],
      numCols: number
    ): PreviewOutcome[][] {
      const columns: PreviewOutcome[][] = [];
      if (!items || items.length === 0 || numCols <= 0) return columns;
      const total = items.length;
      const base = Math.floor(total / numCols);
      const remainder = total % numCols;
      let start = 0;
      for (let i = 0; i < numCols; i++) {
        const size = base + (i < remainder ? 1 : 0);
        const end = start + size;
        if (size > 0) {
          columns.push(items.slice(start, end));
        }
        start = end;
      }
      return columns;
    },
    buildOutcomeColumnsFromOddGroup(
      oddGroup: PreviewOdd[]
    ): PreviewOutcome[][] {
      // Raccogli tutti gli outcome da tutti gli spread nell'oddGroup
      const allOutcomes: PreviewOutcome[] = [];
      oddGroup.forEach(odd => {
        if (Array.isArray(odd.outcome)) {
          // Aggiungi marketUniqueId a ogni outcome
          allOutcomes.push(
            ...odd.outcome.map(outcome => ({
              ...outcome,
              marketUniqueId: odd.unique_id
            }))
          );
        }
      });

      const firstOdd = oddGroup[0];
      if (!firstOdd) return [];

      // Se è un mercato con risultato esatto (correctMarket)
      if (
        firstOdd.id == this.correctMarket ||
        firstOdd.id == this.correctMarket2
      ) {
        return this.getCorrectData(allOutcomes);
      }

      // Se il mercato ha odd_with_specifier, raggruppa per id_outcome
      if (firstOdd.odd_with_specifier) {
        const groupedByOutcomeId: Record<number, PreviewOutcome[]> = {};
        allOutcomes.forEach((outcome: PreviewOutcome) => {
          const idOutcome = outcome.id_outcome;
          if (!groupedByOutcomeId[idOutcome]) {
            groupedByOutcomeId[idOutcome] = [];
          }
          groupedByOutcomeId[idOutcome].push(outcome);
        });
        // Crea una colonna per ogni gruppo di id_outcome
        return Object.values(groupedByOutcomeId);
      }

      // Altrimenti distribuisci gli outcome in colonne
      const total = allOutcomes.length;
      if (total > 4) {
        let cols = 1;
        if (total % 3 === 0) {
          cols = 3;
        } else if (total % 2 === 0) {
          cols = 2;
        }
        return this.distributeIntoColumns(allOutcomes, cols);
      }
      return allOutcomes.map(outcome => [outcome]);
    },
    getOutcomeNamesFromOddGroup(oddGroup: PreviewOdd[]): string[] {
      const names = new Set<string>();
      oddGroup.forEach(odd => {
        if (Array.isArray(odd.outcome)) {
          odd.outcome.forEach(outcome => {
            const name = outcome.outcome_alias || outcome.outcome_name;
            if (name) {
              names.add(name);
            }
          });
        }
      });
      return Array.from(names);
    },
    getSpreadOptionsFromOddGroup(
      oddGroup: PreviewOdd[]
    ): GenericOption[] | null {
      if (oddGroup.length <= 1) return null;

      const spreadSet = new Set<string>();
      oddGroup.forEach(odd => {
        if (odd.specifier && !odd.outcomeAreAllClosed) {
          spreadSet.add(odd.specifier);
        }
      });

      if (spreadSet.size === 0) return null;

      return Array.from(spreadSet).map(specifier => ({
        label: specifier,
        value: specifier
      }));
    },
    async loadTournamentForCategory(categoryID: string) {
      this.isTournamentsListLoading = true;
      await this.$store.dispatch(
        'IllinoisSport/fetchTournamentsForCategoryIfNeeded',
        { sportId: this.sportId, categoryId: categoryID }
      );

      this.isTournamentsListLoading = false;
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    }
  },
  computed: {
    event(): EventDetailsEvent | null {
      return (
        this.$store.getters['IllinoisSport/getEventById'](this.eventId)
          ?.event || null
      );
    },
    oddsRecord(): PreviewOdd[] {
      return (
        this.$store.getters['IllinoisSport/getEventById'](this.eventId)
          ?.oddsByMarketGroup[this.activeMarketGroup] || []
      );
    },
    marketGroups(): { label: string; value: string }[] {
      const groups =
        this.$store.getters['IllinoisSport/getEventById'](
          this.eventId
        )?.marketsGroups?.map((group: EventDetailsMarketsGroup) => ({
          label: group.name,
          value: group._id
        })) || [];
      console.log('marketGroups', groups);
      return groups;
    },

    odds(): PreviewOdd[][] {
      const oddsArray = this.oddsRecord;
      if (!Array.isArray(oddsArray) || oddsArray.length === 0) {
        return [];
      }
      // Raggruppa per id market
      const grouped: Record<number, PreviewOdd[]> = {};
      oddsArray.forEach((odd: PreviewOdd) => {
        const marketId = odd.id;
        if (!grouped[marketId]) {
          grouped[marketId] = [];
        }
        grouped[marketId].push(odd);
      });
      const orderedGroup = Object.values(grouped).sort(
        (a: PreviewOdd[], b: PreviewOdd[]) => {
          return a[0].sort - b[0].sort;
        }
      );
      return orderedGroup;
    },
    filteredOdds(): PreviewOdd[][] {
      const odds = this.odds || [];
      console.log('odds', odds);
      const filtered = odds
        .map((oddGroup: PreviewOdd[]) => {
          // Filtra le odds con outcomeAreAllClosed === true all'interno di ogni gruppo
          return oddGroup.filter((odd: PreviewOdd) => !odd.outcomeAreAllClosed);
        })
        .filter((oddGroup: PreviewOdd[]) => {
          // Filtra i gruppi che hanno almeno una odd con outcome attivi
          return oddGroup.length > 0 && this.hasActiveOutcomes(oddGroup);
        });
      console.log('filtered', filtered);
      return filtered;
    },
    tournaments(): Tournament[] {
      return this.$store.getters['IllinoisSport/getTournamentsByCategory'](
        this.categoryId
      );
    },
    events(): PreviewEventGroup[] {
      return this.$store.getters['IllinoisSport/getEventsByTournament'](
        this.tournamentSelectedId
      );
    },
    selectedCategoryName(): string {
      console.log('selectedCategoryName', this.categoryId);
      const categories = this.$store.getters[
        'IllinoisSport/getCategoriesBySport'
      ](this.sportId);
      console.log('selectedCategoryName categories', categories);
      const categoryName = categories.find(
        category => category.categoryId.toString() === this.categoryId
      )?.name;
      console.log('selectedCategoryName categoryName', categoryName);
      return categoryName || '';
    },
    skeletonEvent(): any {
      return { home: '', away: '', scheduled: '' } as any;
    },
    skeletonOdds(): any {
      return [[], [], []] as any;
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize, {
      passive: true
    });
    this.loading = true;
    window.parent.postMessage(
      {
        type: 'illinoisEventOpened',
        eventId: this.eventId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        tournamentId: this.tournamentId
      },
      '*'
    );
    try {
      await this.$store.dispatch('IllinoisSport/fetchEventDetailsIfNeeded', {
        sportId: this.sportId,
        categoryId: this.categoryId,
        tournamentId: this.tournamentId,
        eventId: this.eventId
      });
    } finally {
      this.loading = false;
    }
    // Fetch categorie in background, senza bloccare lo skeleton
    this.$store.dispatch('IllinoisSport/fetchCategoriesIfNeeded', {
      sportId: this.sportId
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    marketGroups: {
      immediate: true,
      handler(groups) {
        const groupIds = (groups || []).map((g: { value: string }) => g.value);
        if (
          (!this.activeMarketGroup && groups && groups.length) ||
          (this.activeMarketGroup && !groupIds.includes(this.activeMarketGroup))
        ) {
          this.activeMarketGroup =
            groups && groups.length ? groups[0].value : null;
        }
      }
    },
    activeMarketGroup(newVal) {
      console.log('activeMarketGroup', newVal);
      if (newVal && !this.loading) {
        this.isMarketLoading = true;
        this.$store
          .dispatch('IllinoisSport/fetchEventMarketGroupsIfNeeded', {
            eventId: this.eventId,
            groupId: newVal,
            sportId: this.sportId,
            categoryId: this.categoryId,
            tournamentId: this.tournamentId
          })
          .finally(() => {
            this.isMarketLoading = false;
          });
      }
    },
    oddsRecord: {
      immediate: true,
      handler(oddsArray: PreviewOdd[]) {
        if (!Array.isArray(oddsArray) || oddsArray.length === 0) {
          return;
        }
        // Raggruppa per id market e estrae i specifier
        const defaults: Record<string, string> = {};
        const grouped: Record<number, PreviewOdd[]> = {};
        oddsArray.forEach((odd: PreviewOdd) => {
          const marketId = odd.id.toString();
          if (!grouped[odd.id]) {
            grouped[odd.id] = [];
          }
          grouped[odd.id].push(odd);
        });
        Object.entries(grouped).forEach(([marketId, odds]) => {
          if (odds[0]?.specifier) {
            defaults[marketId] = odds[0].specifier;
          }
        });

        const current = this.activeSpread || {};
        const merged: Record<string, string> = { ...current };
        Object.keys(defaults).forEach(key => {
          if (!(key in merged)) {
            merged[key] = defaults[key];
          }
        });
        this.activeSpread = merged;
      }
    },
    eventId: {
      async handler(newVal) {
        console.log('eventId', newVal);
        // Attiva placeholder durante lo switch evento
        this.loading = true;
        // Reset stato legato all'evento precedente per forzare il ricalcolo
        this.openChangeGameMenu = false;
        this.showTournamentsList = true;
        this.tournamentSelectedId = this.tournamentId;
        this.tournamentSelectedName = '';
        this.activeMarketGroup = null;
        this.activeSpread = {} as Record<string, string>;
        await this.$store.dispatch('IllinoisSport/fetchEventDetailsIfNeeded', {
          sportId: this.sportId,
          categoryId: this.categoryId,
          tournamentId: this.tournamentId,
          eventId: newVal
        });
        // Carica gli eventi per il tournament corrente quando cambia l'eventId
        await this.fetchEventsByTournament({
          sportId: this.sportId,
          categoryId: this.categoryId,
          tournamentId: this.tournamentId.toString()
        });
        this.loading = false;
        // Carica categorie in background senza bloccare lo scheletro
        this.$store.dispatch('IllinoisSport/fetchCategoriesIfNeeded', {
          sportId: this.sportId
        });
      }
    },
    tournamentId: {
      async handler(newVal) {
        // Quando cambia il tournamentId dalla route, aggiorna tournamentSelectedId e carica gli eventi
        if (newVal && newVal !== this.tournamentSelectedId) {
          this.tournamentSelectedId = newVal;
          await this.fetchEventsByTournament({
            sportId: this.sportId,
            categoryId: this.categoryId,
            tournamentId: newVal.toString()
          });
        }
      }
    }
  }
});
